import React, { useState } from 'react';
import axios from 'axios';

const BlueDartWaybillGenerator = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [waybillData, setWaybillData] = useState(null);

  const requestData = {
    Request: {
      Consignee: {
        AvailableDays: "",
        AvailableTiming: "",
        ConsigneeAddress1: "88 NAGORI MOHALLA",
        ConsigneeAddress2: "UJJAIN",
        ConsigneeAddress3: "UJJAIN",
        ConsigneeAddressType: "",
        ConsigneeAddressinfo: "",
        ConsigneeAttention: "",
        ConsigneeBusinessPartyTypeCode: "",
        ConsigneeCityName: "",
        ConsigneeCountryCode: "",
        ConsigneeEmailID: "",
        ConsigneeFiscalID: "",
        ConsigneeFiscalIDType: "",
        ConsigneeFullAddress: "",
        ConsigneeGSTNumber: "",
        ConsigneeID: "",
        ConsigneeIDType: "",
        ConsigneeLatitude: "",
        ConsigneeLongitude: "",
        ConsigneeMaskedContactNumber: "",
        ConsigneeMobile: "9111496265",
        ConsigneeName: "MUSHIR NAGORI",
        ConsigneePincode: "456001",
        ConsigneeStateCode: "",
        ConsigneeTelephone: "",
        ConsingeeFederalTaxId: "",
        ConsingeeRegistrationNumber: "",
        ConsingeeRegistrationNumberIssuerCountryCode: "",
        ConsingeeRegistrationNumberTypeCode: "",
        ConsingeeStateTaxId: ""
      },
      Returnadds: {
        ManifestNumber: "",
        ReturnAddress1: "",
        ReturnAddress2: "",
        ReturnAddress3: "",
        ReturnAddressinfo: "",
        ReturnContact: "",
        ReturnEmailID: "",
        ReturnLatitude: "",
        ReturnLongitude: "",
        ReturnMaskedContactNumber: "",
        ReturnMobile: "",
        ReturnPincode: "",
        ReturnTelephone: ""
      },
      Services: {
        AWBNo: "",
        ActualWeight: "1.0",
        AdditionalDeclaration: "",
        AuthorizedDealerCode: "",
        BankAccountNumber: "",
        BillToAddressLine1: "",
        BillToCity: "",
        BillToCompanyName: "",
        BillToContactName: "",
        BillToCountryCode: "",
        BillToCountryName: "",
        BillToFederalTaxID: "",
        BillToPhoneNumber: "",
        BillToPostcode: "",
        BillToState: "",
        BillToSuburb: "",
        BillingReference1: "",
        BillingReference2: "",
        CessCharge: 0.0,
        CollectableAmount: 0.0,
        Commodity: {
          CommodityDetail1: "HARBAL",
          CommodityDetail2: "",
          CommodityDetail3: ""
        },
        CreditReferenceNo: "852025",
        CreditReferenceNo2: "",
        CreditReferenceNo3: "",
        CurrencyCode: "",
        DeclaredValue: 2300.00,
        DeliveryTimeSlot: "",
        Dimensions: [
          {
            Breadth: 10.00,
            Count: 1,
            Height: 10.00,
            Length: 20.00
          }
        ],
        ECCN: "",
        EsellerPlatformName: "",
        ExchangeWaybillNo: "",
        ExportImportCode: "",
        ExportReason: "",
        ExporterAddressLine1: "",
        ExporterAddressLine2: "",
        ExporterAddressLine3: "",
        ExporterBusinessPartyTypeCode: "",
        ExporterCity: "",
        ExporterCompanyName: "",
        ExporterCountryCode: "",
        ExporterCountryName: "",
        ExporterDivision: "",
        ExporterDivisionCode: "",
        ExporterEmail: "",
        ExporterFaxNumber: "",
        ExporterMobilePhoneNumber: "",
        ExporterPersonName: "",
        ExporterPhoneNumber: "",
        ExporterPostalCode: "",
        ExporterRegistrationNumber: "",
        ExporterRegistrationNumberIssuerCountryCode: "",
        ExporterRegistrationNumberTypeCode: "",
        ExporterSuiteDepartmentName: "",
        FavouringName: "",
        ForwardAWBNo: "",
        ForwardLogisticCompName: "",
        FreightCharge: 0.0,
        GovNongovType: "",
        IncotermCode: "",
        InsuranceAmount: 0.0,
        InsurancePaidBy: "",
        InsurenceCharge: 0.0,
        InvoiceNo: "",
        IsCargoShipment: false,
        IsChequeDD: "",
        IsCommercialShipment: false,
        IsDedicatedDeliveryNetwork: false,
        IsDutyTaxPaidByShipper: false,
        IsEcomUser: false,
        IsForcePickup: false,
        IsIntlEcomCSBUser: false,
        IsPartialPickup: false,
        IsReversePickup: false,
        ItemCount: 1,
        MarketplaceName: "",
        MarketplaceURL: "",
        NFEIFlag: false,
        NotificationMessage: "",
        Officecutofftime: "",
        OrderURL: "",
        PDFOutputNotRequired: false,
        PackType: "",
        ParcelShopCode: "",
        PayableAt: "",
        PayerGSTVAT: 0.0,
        PickupDate: "/Date(1736504552000)/",
        PickupMode: "",
        PickupTime: "1600",
        PickupType: "O",
        PieceCount: "1",
        PreferredPickupTimeSlot: "",
        ProductCode: "A",
        ProductFeature: "",
        ProductType: 2,
        RegisterPickup: false,
        ReverseCharge: 0.0,
        SignatureName: "",
        SignatureTitle: "",
        SpecialInstruction: "",
        SubProductCode: "P",
        SupplyOfIGST: "",
        SupplyOfwoIGST: "",
        TermsOfTrade: "",
        TotalCashPaytoCustomer: 0.0,
        Total_IGST_Paid: 0.0,
        itemImg: [
          {
            AWBNo: "",
            ImageURL: "https://m.media-amazon.com/images/I/71MW1E0je-L._SX522_.jpg",
            ItemID: "Test Item ID1"
          },
          {
            AWBNo: "",
            ImageURL: "https://m.media-amazon.com/images/I/61LNnZPoKPS._SL1500_.jpg",
            ItemID: "Test Item ID1"
          }
        ],
        itemdtl: [
          {
            CGSTAmount: 0.0,
            CommodityCode: "",
            Discount: 0.0,
            HSCode: "",
            IGSTAmount: 0.0,
            IGSTRate: 0.0,
            Instruction: "",
            InvoiceNumber: "",
            IsMEISS: "",
            ItemID: "Test Item ID1",
            ItemName: "Test Item1",
            ItemValue: 0.0,
            Itemquantity: 0,
            LicenseNumber: "",
            ManufactureCountryCode: "",
            ManufactureCountryName: "",
            PerUnitRate: 0.0,
            PieceID: "",
            PieceIGSTPercentage: 0.0,
            PlaceofSupply: "",
            ProductDesc1: "",
            ProductDesc2: "",
            ReturnReason: "",
            SGSTAmount: 0.0,
            SKUNumber: "",
            SellerGSTNNumber: "",
            SellerName: "",
            SubProduct1: "Test Sub 1",
            SubProduct2: "Test Sub 2",
            SubProduct3: "Test Sub 3",
            SubProduct4: "Test Sub 4",
            TaxableAmount: 0.0,
            TotalValue: 0.0,
            Unit: "",
            Weight: 0.0,
            cessAmount: "0.0",
            countryOfOrigin: "",
            docType: "",
            subSupplyType: 0,
            supplyType: ""
          }
        ],
        noOfDCGiven: 0
      },
      Shipper: {
        CustomerAddress1: "DHANVANTRI AYURVEDIC NEAR,",
        CustomerAddress2: "MENGONATH",
        CustomerAddress3: "UJJAIN",
        CustomerAddressinfo: "",
        CustomerBusinessPartyTypeCode: "",
        CustomerCode: "313460",
        CustomerEmailID: "test@gmail.com",
        CustomerFiscalID: "",
        CustomerFiscalIDType: "",
        CustomerGSTNumber: "",
        CustomerLatitude: "",
        CustomerLongitude: "",
        CustomerMaskedContactNumber: "",
        CustomerMobile: "9111496265",
        CustomerName: "PUSHPANJALI ECONIRMIT",
        CustomerPincode: "456001",
        CustomerRegistrationNumber: "",
        CustomerRegistrationNumberIssuerCountryCode: "",
        CustomerRegistrationNumberTypeCode: "",
        CustomerTelephone: "",
        IsToPayCustomer: false,
        OriginArea: "UJJ",
        Sender: "",
        VendorCode: ""
      }
    },
    Profile: {
      Api_type: "S",
      Area: "UJJ",
      Customercode: "313460",
      IsAdmin: "",
      LicenceKey: "hugurthljkfzqmkm3tmjuokqiomjeosk",
      LoginID: "UJJ23580",
      Version: "1.8"
    }
  };

  const generateWaybill = async () => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    
    try {
      const response = await axios.post(
        'https://apigateway.bluedart.com/in/transportation/waybill/v1/GenerateWayBill',
        requestData,
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'JWTToken': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJzdWJqZWN0LXN1YmplY3QiLCJhdWQiOlsiYXVkaWVuY2UxIiwiYXVkaWVuY2UyIl0sImlzcyI6InVybjpcL1wvYXBpZ2VlLWVkZ2UtSldULXBvbGljeS10ZXN0IiwiZXhwIjoxNzUxOTcyNDMyLCJpYXQiOjE3NTE4ODYwMzIsImp0aSI6IjhlYjI1ODYzLWU3NmEtNGI2ZC1hMGU0LTBjNWE2MjY2ODg4NyJ9.9edXofK3dLYu7D3vrUedHs4wAXvm6nmJW558GUnw9N4'
          }
        }
      );
      
      setWaybillData(response.data);
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to generate waybill');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="blue-dart-waybill-generator">
      <h2>Blue Dart Waybill Generator</h2>
      
      <button 
        onClick={generateWaybill} 
        disabled={loading}
        className="generate-button"
      >
        {loading ? 'Generating...' : 'Generate Waybill'}
      </button>
      
      {error && (
        <div className="error-message">
          Error: {error}
        </div>
      )}
      
      {success && (
        <div className="success-message">
          Waybill generated successfully!
          {waybillData && (
            <pre className="waybill-data">
              {JSON.stringify(waybillData, null, 2)}
            </pre>
          )}
        </div>
      )}
      
      <style jsx>{`
        .blue-dart-waybill-generator {
          max-width: 800px;
          margin: 0 auto;
          padding: 20px;
          font-family: Arial, sans-serif;
        }
        
        .generate-button {
          background-color: #007bff;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 4px;
          cursor: pointer;
          font-size: 16px;
        }
        
        .generate-button:hover {
          background-color: #0056b3;
        }
        
        .generate-button:disabled {
          background-color: #cccccc;
          cursor: not-allowed;
        }
        
        .error-message {
          color: #dc3545;
          margin-top: 15px;
          padding: 10px;
          border: 1px solid #dc3545;
          border-radius: 4px;
          background-color: #f8d7da;
        }
        
        .success-message {
          color: #28a745;
          margin-top: 15px;
          padding: 10px;
          border: 1px solid #28a745;
          border-radius: 4px;
          background-color: #d4edda;
        }
        
        .waybill-data {
          background-color: #f8f9fa;
          padding: 15px;
          border-radius: 4px;
          overflow-x: auto;
          margin-top: 10px;
          font-size: 14px;
        }
      `}</style>
    </div>
  );
};

export default BlueDartWaybillGenerator;